import axios from 'axios';
import log from '../../logger';

/**
 * Import a theme package
 * @param {File} themePackage - The theme package zip file to import
 * @returns {Promise<Object>} - Response with status
 */
export const importTheme = async (themePackage) => {
  const formData = new FormData();
  formData.append('themePackage', themePackage);

  try {
    const { data } = await axios.post('/plugins/theme/api/importTheme', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    log.log('Theme was imported successfully. Response:', data);
    return data;
  } catch (error) {
    log.error('Error importing theme:', error);
    throw error;
  }
};

/**
 * Export the current theme
 * @returns {Promise<Object>} - Response with packageDownloadUrl
 */
export const exportTheme = async () => {
  try {
    const { data } = await axios.get('/plugins/theme/api/exportTheme');
    log.log('Theme was exported successfully. Response:', data);
    return data;
  } catch (error) {
    log.error('Error exporting theme:', error);
    throw error;
  }
};
